<!DOCTYPE html>
<html>
<head>
  <style>
    img {
      display: block;
      margin-left: auto;
      margin-right: auto;
      text-align: justify;
    }

    body {
      background: transparent;
    }
  </style>
</head>
<body>

  <p><b>Tabela de maré:</b></p>
  <p align="justify">
    Os valores apresentados na tabela correspondem à análise harmónica do Instituto Hidrográfico para o local do marégrafo de Aveiro.
    Devido à variação do nível médio do mar, são de esperar alturas de água superiores, em cerca de 0.1 m, aos valores previstos indicados na tabela. As previsões foram calculadas através de análise harmónica. As alturas de maré são referidas ao nível do zero hidrográfico.
    Zero hidrográfico: 2,00 m abaixo do nível médio adotado (Cascais, 1938); 6,980 m abaixo da marca de contacto (MC);
    6,149 m abaixo da marca de nivelamento principal NP 174 (IGP) situada no passeio fronteiro à porta do farol da Barra.
  </p>
  <p>O valor entre parênteses corresponde à sobre-elevação prevista pela HIDROMOD, com base no modelo numérico de escala local.</p>

  <p><b>Medição</b></p>
  <p align="justify">
    O valor medido correspondem à última leitura disponível para o marégrafo de Aveiro, que é mantido pelo Instituto Hidrográfico.
  </p>

  <p><b>Previsão</b></p>
  <p align="justify">
    As previsões provêm da implementação do modelo numérico de previsão hidrodinâmico MOHID para a região da Ria de Aveiro.
    Este modelo operacional tem uma resolução horizontal de 50 m e é atualizado diariamente pela Hidromod.
  </p>

  <p align="justify">As previsões do nível do mar são fornecidas para o local do marégrafo de Aveiro, localizado no molhe central da Barra de Aveiro (40&#176;38,65'N;8&#176;44,92'W).</p>
  <p>As previsões de intensidade da corrente são fornecidas para o canal principal (P6: 40&#176;38,43'N;8&#176;44,52'W).</p>

  <p></p>
  <p><b>Unidades das variáveis:</b></p>
  <UL>
    <LI>Nível do mar: metros [m];</LI>
    <LI>Intensidade da corrente: nós [nós];</LI>
    <LI>Direção da corrente: graus [°].</LI>
  </UL>

</body>
</html>
